<div class="schedule-info-wrapper" *ngIf="scheduleData">
    <div class="calendar-column">
        <finder-calendar
            class="calendar"
            [(date)]="date"
            [maxDays]="scheduleData.maxDays"
            (dateSelected)="onDateSelected($event)"
        >
        <p class="schedule-more-link" calendar-link>
            <a finderLocale
                finderLinkId
                [href]="scheduleData.moreLink"
                target="_self"
                tabindex="0"
            >{{scheduleData.moreLinkLabel}}</a>
        </p>
        </finder-calendar>
    </div>
    <div class="calendar-column schedule-text">
        <p>{{selectedDay}}</p>
        <p *ngIf="locationData">
            <strong>{{locationData.label}} {{scheduleData.label}}</strong>
        </p>
        <p *ngFor="let schedule of schedules$$()">
            {{schedule.startTime | FormatTime}}
            {{scheduleData.toHourText}}
            {{schedule.endTime | FormatTime}}
            {{schedule.type | scheduleType}}
        </p>
    </div>
</div>
